module.exports = __webpack_public_path__ + "static/img/at.154cee6c.svg";